<template>
  <el-card class="box-card full-screen batch-operation-review">
    <el-page-header @back="$router.go(-1)" :title="$t('Back')">
      <template slot="content">
        <span style="font-size: 14px">
          {{ $t("remittanceBusiness") }} / {{ $t("batchOfRemittanceReversal") }}
        </span>
      </template>
    </el-page-header>

    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('transactionInfoId')" size="small">
          <el-input v-model="queryForm.applyCode" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('region')">
          <el-select
            v-model="queryForm.region"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <!-- 国 -->
            <template v-for="(item, i) in countryList">
              <el-option-group
                v-if="item.parentId == 0"
                :key="i"
                :label="$t(item.name)"
              >
                <!-- 省 -->
                <template v-for="(t, i) in countryList">
                  <el-option
                    v-if="t.parentId == item.id"
                    :key="i"
                    :label="$t(t.name)"
                    :value="t.id"
                  ></el-option>
                </template>
              </el-option-group>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
          <el-button size="small" @click="onReset">{{ $t("reset") }}</el-button>
        </el-form-item>
      </el-form>
      <el-row class="table-btns">
        <a @click="downloadEXCEL()" type="text" size="mini"
          ><i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}</a
        >
      </el-row>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="applyCode"
          :label="$t('transactionInfoId')"
          fixed="left"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="account"
          :label="$t('transaction account')"
          fixed="left"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="tranType"
          :label="$t('dealType')"
          fixed="left"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.tranType == 1">{{
              $t("batchOfRemittance")
            }}</span>
            <span v-else-if="scope.row.tranType == 2">{{
              $t("batchTransferAccounts")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('transactionAmount')"
          width="140"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="excelName"
          :label="$t('transaction EXCEL name')"
          show-overflow-tooltip
          width="200"
        ></el-table-column>
        <el-table-column
          prop="payeeCityId"
          :label="$t('beneficiariesAddress')"
          width="160"
        >
          <template slot-scope="scope">
            {{ getCityFullName(scope.row.payeeCityId) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('transaction time')"
          width="140"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.createTime).format("ymdhms") }}
          </template>
        </el-table-column>

        <!-- 、0待审核 1审核通过 2审核失败(大客户只需要自己财务+自己经理审核，这里加了一个审核状态) -->
        <el-table-column
          v-if="loginInfo.type == 'customerLogin'"
          prop="checkStatus"
          :label="$t('checkStatus')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.checkStatus == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-else-if="scope.row.checkStatus == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-else-if="scope.row.checkStatus == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <!-- 、0待审核 1审核通过 2审核失败 -->
        <el-table-column
          v-else
          prop="status"
          :label="$t('checkStatus')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-else-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-else-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          width="140"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyTime">{{
              $manba(scope.row.verifyTime).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyRemark"
          :label="$t('checkRemark') + 1"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column
          prop="checkRemark"
          :label="$t('checkRemark') + 2"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column :label="$t('extend')" fixed="right" width="140">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              :disabled="!isCancellable(scope.row)"
              @click.stop="openCancelDrawer(scope.row)"
            >
              {{ isPlatform ? $t("reverseBatch") : $t("cancel") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="isPlatform ? $t('reverseBatch') : $t('cancelBatch')"
      :visible.sync="cancelDrawer"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapper-closable="false"
      :size="700"
    >
      <div style="padding: 20px">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item :label="$t('applyCode')">
            {{ selectedRows.applyCode }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('applyUser')">
            {{ selectedRows.applyUser }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('amount')">
            <span class="franc">₣</span>
            {{ Number(selectedRows.amount || 0).formatMoney(0) }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('status')">
            {{ $t(statusLabel(selectedRows.status)) }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('creationTime')" :span="2">
            {{
              selectedRows.createTime
                ? $manba(selectedRows.createTime).format("ymdhms")
                : ""
            }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- Lignes du fichier -->
        <el-divider content-position="left">{{
          $t("beneficiaries")
        }}</el-divider>
        <el-table
          :data="rowExcelData"
          v-loading="isItemLoading"
          size="mini"
          max-height="280"
          border
        >
          <el-table-column prop="surname" :label="$t('lastName')" width="120" />
          <el-table-column prop="name" :label="$t('firstName')" width="120" />
          <el-table-column prop="phone" :label="$t('phone')" width="140" />
          <el-table-column prop="amount" :label="$t('amount')" width="120">
            <template slot-scope="s">
              <span class="franc">₣</span
              >{{ Number(s.row.amount || 0).formatMoney(0) }}
            </template>
          </el-table-column>
          <el-table-column prop="statusName" :label="$t('status')" width="120">
            <template slot-scope="s">{{ $t(s.row.statusName) }}</template>
          </el-table-column>
        </el-table>

        <!-- Avertissement plateforme -->
        <el-alert
          v-if="isPlatform"
          :title="$t('reverseBatchWarning')"
          type="warning"
          :closable="false"
          show-icon
          style="margin-top: 16px"
        />

        <!-- Raison -->
        <el-form size="small" label-position="top" style="margin-top: 16px">
          <el-form-item :label="$t('reason')" required>
            <el-input
              type="textarea"
              :rows="3"
              v-model="cancelReason"
              :placeholder="$t('reason')"
            />
          </el-form-item>
        </el-form>

        <div class="bottom-button">
          <el-button type="danger" :loading="isCancelling" @click="onCancel">
            {{ isPlatform ? $t("reverseBatch") : $t("cancelBatch") }}
          </el-button>
          <el-button @click="cancelDrawer = false">{{
            $t("cancel")
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </el-card>
</template>

<script>
import batchApply from "@/api/batchApply";
import customerBusiness from "@/api/customerBusiness";
import qs from "qs";

export default {
  name: "batchOfRemittanceReversal",
  data() {
    return {
      queryForm: { date: null, businessCode: "", status: null },
      operations: [
        { code: "70", label: "transferAccounts" },
        { code: "71", label: "batchTransferAccounts" },
        { code: "72", label: "accountRemittanceNotAccount" },
        { code: "73", label: "batchOfRemittance" },
      ],
      cancelReason: "",
      isCancelling: false,
      cancelDrawer: false,
      isItemLoading: false,
      selectedRows: {},
      rowExcelData: [],
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      isLoading: false,
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,

      collapseActiveNames: ["1", "2"],
      checkForm: {},
      checkRules: {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "change",
          },
        ],
        verifyRemark: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    cascader() {
      return this.$store.state.format.cascader;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    downloadUrl() {
      let param = JSON.parse(JSON.stringify(this.queryForm));
      return (
        customerBusiness.advancedCustomerTranExport + "?" + qs.stringify(param)
      );
    },
    isPlatform() {
      return this.loginInfo.type !== "customerLogin";
    },
    canCancel() {
      const s = Number(this.selectedRows.status);
      return this.isPlatform ? s === 1 : s === 0;
    },
  },
  methods: {
    getList() {
      this.isLoading = true;

      const params = { ...this.queryForm };
      if (params.date && params.date.length === 2) {
        params.startTime = this.$manba(params.date[0]).format("ymd");
        params.endTime = this.$manba(params.date[1]).format("ymd");
      }
      delete params.date;

      if (
        params.status === undefined ||
        params.status === null ||
        params.status === ""
      )
        params.status = this.isPlatform ? 1 : 0;

      const api = this.isPlatform
        ? batchApply.getPage
        : customerBusiness.pageBatchApply;

      api({
        param: { current: this.currentPage, size: this.pageSize, ...params },
        success: (res) => {
          this.tableData = res.data || {};
          this.isLoading = false;
        },
        failing: () => {
          this.isLoading = false;
        },
      });
    },
    onReset() {
      this.queryForm = {
        date: null,
        businessCode: "",
        region: "",
      };
      this.currentPage = 1;
      this.getList();
    },
    downloadEXCEL() {
      let download = document.createElement("a");
      download.href = this.downloadUrl;
      download.download = "";
      download.click();
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    query() {
      this.$set(this, "currentPage", 1);
      this.$set(this, "tableData", {});
      this.getList();
    },
    getCityFullName(cityId) {
      if (!cityId || !this.countryList.length) return "-";

      const city = this.countryList.find((c) => c.id == cityId);
      if (!city) return "-";

      const region = this.countryList.find((c) => c.id == city.parentId);

      const country = region
        ? this.countryList.find((c) => c.id == region.parentId)
        : null;

      return [country, region, city]
        .filter(Boolean)
        .map((c) => c.name)
        .join(" / ");
    },
    getRegionName(arr) {
      let name = "";
      for (let i in arr) {
        let tt = this.countryList.find(function (t) {
          return t.id == arr[i];
        });
        name += tt ? tt.name + " " : "";
      }
      return name.substring(0, name.length - 1);
    },

    showDrawerRowExcel(item) {
      this.$set(this, "isItemLoading", true);
      if (this.loginInfo.type == "customerLogin") {
        customerBusiness.pageBatchRemittanceTransferImport({
          param: { excelName: item.excelName, size: -1 },
          success: (res) => {
            this.$set(this, "rowExcelData", res.data?.records);
            this.$set(this, "isItemLoading", false);
          },
        });
      } else {
        batchApply.pageBatchRemittanceTransferImport({
          param: { excelName: item.excelName, size: -1 },
          success: (res) => {
            this.$set(this, "rowExcelData", res.data?.records);
            this.$set(this, "isItemLoading", false);
          },
        });
      }

      this.$set(this, "selectedRows", item);

      this.drawerRowExcel = true;
    },

    onSubmitCheck(refName) {
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        if (this.loginInfo.type == "customerLogin") {
          customerBusiness.cancelBatchApply({
            param: { id: this.selectedRows.id, reason: this.cancelForm.reason },
            success: (res) => {
              if (res.code == 200) {
                this.$set(
                  this.selectedRows,
                  "status",
                  Number(this.checkForm.status),
                );
                this.$set(
                  this.selectedRows,
                  "verifyRemark",
                  this.checkForm.verifyRemark,
                );
                this.$message({
                  type: "success",
                  message: res.msg || this.$t("operateSuccessfully"),
                });
              } else
                this.$message({
                  type: "error",
                  message:
                    (res.msg || this.$t("operationFailure")) + ";" + res.code,
                });
            },
          });
        } else {
          batchApply.reverseBatchApply({
            param: { id: this.selectedRows.id, reason: this.cancelForm.reason },
            success: (res) => {
              if (res.code == 200) {
                this.$set(
                  this.selectedRows,
                  "status",
                  Number(this.checkForm.status),
                );
                this.$set(
                  this.selectedRows,
                  "verifyRemark",
                  this.checkForm.verifyRemark,
                );
                this.$message({
                  type: "success",
                  message: res.msg || this.$t("operateSuccessfully"),
                });
              } else
                this.$message({
                  type: "error",
                  message:
                    (res.msg || this.$t("operationFailure")) + ";" + res.code,
                });
            },
          });
        }
      });
    },

    isCancellable(row) {
      const s = Number(row.status);
      return this.isPlatform ? s === 1 : s === 0;
    },

    statusLabel(status) {
      const map = {
        0: "checkPending",
        1: "getApproved",
        2: "notApproved",
        3: "cancelled",
      };
      return map[Number(status)] || "";
    },

    openCancelDrawer(row) {
      this.selectedRows = row;
      this.cancelReason = "";
      this.rowExcelData = [];
      this.cancelDrawer = true;

      this.isItemLoading = true;
      const api = this.isPlatform
        ? batchApply.pageBatchRemittanceTransferImport
        : customerBusiness.pageBatchRemittanceTransferImport;

      api({
        param: { excelName: row.excelName, size: -1 },
        success: (res) => {
          this.rowExcelData = (res.data && res.data.records) || [];
          this.isItemLoading = false;
        },
        failing: () => {
          this.isItemLoading = false;
        },
      });
    },

    onCancel() {
      if (!this.cancelReason || !this.cancelReason.trim()) {
        this.$message.warning(this.$t("requiredFields"));
        return;
      }

      this.$confirm(
        this.$t(this.isPlatform ? "reverseBatchConfirm" : "cancelBatchConfirm"),
        this.$t("confirm"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          type: "warning",
        },
      )
        .then(() => {
          this.isCancelling = true;

          const call = this.isPlatform
            ? batchApply.reverseBatchApply
            : customerBusiness.cancelBatchApply;

          const param = this.isPlatform
            ? {
                applyId: this.selectedRows.id,
                reason: this.cancelReason.trim(),
              }
            : { id: this.selectedRows.id, reason: this.cancelReason.trim() };

          call({
            param,
            success: (res) => {
              this.isCancelling = false;
              if (res.code === 200) {
                this.$message.success(this.$t("operateSuccessfully"));
                this.cancelDrawer = false;
                this.cancelReason = "";
                this.getList();
              } else {
                this.$message.error(
                  this.$t(res.msg) || this.$t("operationFailure"),
                );
              }
            },
            failing: () => {
              this.isCancelling = false;
              this.$message.error(this.$t("networkError"));
            },
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    if (!this.countryList || this.countryList.length === 0) {
      this.$store.dispatch("globalParameter/getCountry");
    }
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.functional-zone {
  margin-top: 20px;
  /deep/.el-radio {
    margin-right: 0;
  }
  /deep/.el-form-item:last-child {
    .el-form-item__label {
      height: 32px;
    }
  }
  /deep/.el-form-item:nth-child(2) {
    width: 40%;
  }
}
.jiaoyirenxx {
  .el-col {
    margin: 5px 0;
    div {
      color: #999;
    }
  }
}
/deep/.el-collapse-item__header {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.table-btns a {
  cursor: pointer;
}
</style>
